import React, { useState } from "react";
import MenuIcon from "resources/img/menu-icon.svg";
import styled from "styled-components";
import LateralMenu from "./LateralMenu";
import CurrencyOptions from "components/currency";
import { ToggleButton as WeatherToggleButton } from "@appsinti/weather-frontend";

const Container = styled.div`
  width: 38%;
  max-width: 38%;
  justify-content: flex-end;
  display: flex;
  order: 4;
  gap: 0px;
  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
  }
`;

const Menu = styled.img`
  width: 23px;
  height: 23px;

  @media screen and (max-width: 335px) {
    width: 22px;
    height: 22px;
  }
`;

const WeatherToggleContainer = styled.div`
  position: relative;
  width: 5rem;
  transform: scale(.9);
`;

export const ShowMenu: React.FC<{ headerHeight: number | undefined; }> = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Container>
        <WeatherToggleContainer>
          <WeatherToggleButton />
        </WeatherToggleContainer>   
        
        <CurrencyOptions />

        <div className="icon-container" onClick={toggle}>
          <Menu src={MenuIcon} alt={"isOpen-menu"} />
        </div>
      </Container>
      {isOpen && <LateralMenu toggle={toggle} isOpen={isOpen} />}
    </>
  );
};
